<template>
  <v-container grid-list-xs fluid>
    <form-dialog v-model="dialog" :title="formTitle" @input="reset">
      <v-sheet class="py-2 px-4">
        <v-text-field
          data-vv-name="name"
          v-validate="'required'"
          label="Training Title"
          v-model="workshop.name"
          data-vv-as="Training Title"
          :error-messages="errors.collect('name')"
        />
        <v-text-field
          v-validate="'required'"
          data-vv-name="organizer"
          v-model="workshop.organizer"
          label="Training Conducted By"
          data-vv-as="Training Conducted By"
          :error-messages="errors.collect('organizer')"
        />
        <date :label="$t('start_date')" v-model="workshop.start_date" />
        <date :label="$t('end_date')" v-model="workshop.end_date" />
        <v-combobox
          chips
          multiple
          :items="sections"
          v-model="workshop.section"
          :label="$t('section')"
        />
        <v-autocomplete
          chips
          multiple
          :items="csos"
          return-object
          item-value="id"
          item-text="name"
          :label="$t('CSOs')"
          v-model="workshop.csos"
        />
        <v-combobox
          multiple
          small-chips
          label="Other CSOs"
          v-model="workshop.other_csos"
        />
        <div class="my-2 di-flex justify-end">
          <v-btn color="btn_color secondary" :loading="loading" @click="save">{{
            $t("save")
          }}</v-btn>
        </div>
      </v-sheet>
    </form-dialog>
    <!-- DATA TABLE -->
    <v-card class="layout row wrap shadow pa-3">
      <v-flex xs12 class="di-flex align-center grey lighten-4">
        <v-menu offset-y>
          <strong class="title_label pl-2" slot="activator">
            <span>{{ filter.title }}</span>
          </strong>
          <v-list>
            <v-list-tile
              :key="index"
              @click="filter = item"
              v-for="(item, index) in filters"
            >
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-spacer />
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              flat
              v-on="on"
              color="grey darken-2"
              class="ma-0 mr-2 pa-0"
              @click="printTable(false)"
            >
              <v-icon>print</v-icon>
            </v-btn>
          </template>
          <span>Print Table</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              flat
              v-on="on"
              color="grey darken-2"
              class="ma-0 mr-2 pa-0"
              @click="printTable(true)"
            >
              <v-icon>file_download</v-icon>
            </v-btn>
          </template>
          <span>Excel Export</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              class="shadow"
              color="primary"
              v-if="can('add_workshops')"
              @click="dialog = true"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Add New Item</span>
        </v-tooltip>
      </v-flex>
      <v-layout row wrap class="align-center mt-3">
        <v-flex xs12 md6>
          <v-text-field
            small
            outline
            single-line
            hide-details
            class="rounded"
            v-model="search"
            style="max-width:320px"
            :placeholder="$t('search')"
            prepend-inner-icon="mdi-magnify"
          />
        </v-flex>
        <v-flex xs12 md6 class="di-flex justify-end">
          <date
            clearable
            class="mr-2"
            @set="getData"
            v-model="start_date"
            :label="$t('start_date')"
          />
          <date
            clearable
            class="ml-2"
            @set="getData"
            v-model="end_date"
            :label="$t('end_date')"
          />
        </v-flex>
      </v-layout>

      <v-flex xs12>
        <v-data-table
          ref="tbl"
          item-key="id"
          :items="filteredItems"
          :search="search"
          :headers="headers"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.index + 1 }}</td>
            <td>{{ props.item.section.join(", ") }}</td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.organizer }}</td>
            <td>{{ props.item.start_date }}</td>
            <td>{{ props.item.end_date }}</td>
            <td class="font-weight-bold">
              <router-link
                :to="`/CSOs/${cso.id}`"
                v-for="cso in props.item.csos"
                :key="`${props.index}_${cso.id}`"
                >{{ cso.name }},</router-link
              >
              {{ props.item.other_csos && props.item.other_csos.join(", ") }}
            </td>
            <td>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    flat
                    small
                    v-on="on"
                    class="ma-0 pa-0"
                    color="grey darken-2"
                    v-if="can('edit_settings')"
                    @click="editItem(props.item)"
                  >
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Edit</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    flat
                    small
                    v-on="on"
                    class="ma-0 pa-0"
                    color="grey darken-2"
                    v-if="can('edit_settings')"
                    @click="deleteItem(props.item)"
                  >
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "workshops",
  data() {
    return {
      csos: [],
      items: [],
      search: null,
      workshop: {},
      dialog: false,
      loading: false,
      editedIndex: -1,
      start_date: null,
      end_date: null,
      sections: [
        "Internal Governance and Strategic Management",
        "Project Management and Program Delivery",
        "Financial Management",
        "Human Resources",
        "External Relations, Communications and Outreach"
      ],
      filter: { title: "All Traninigs", value: false },
      filters: [
        { title: "All Traninigs", value: false },
        {
          title: "IG&SP",
          value: "Internal Governance and Strategic Management"
        },
        { title: "PM", value: "Project Management and Program Delivery" },
        { title: "FM", value: "Financial Management" },
        { title: "HRM", value: "Human Resources" },
        {
          title: "EXT Comms",
          value: "External Relations, Communications and Outreach"
        }
      ]
    };
  },
  computed: {
    headers: vm => [
      { text: vm.$t("id"), sortable: false, width: "60px" },
      {
        width: "120px",
        value: "section",
        text: vm.$t("section"),
        computed: item => item.section.join(", ")
      },
      { text: "Training Title", value: "name", width: "120px" },
      { text: vm.$t("organizer"), value: "organizer", width: "120px" },
      { text: vm.$t("start_date"), value: "start_date", width: "120px" },
      { text: vm.$t("end_date"), value: "end_date", width: "120px" },
      {
        text: "CSOs Name",
        value: "csos",
        computed: item => {
          let result = item.csos.map(x => x.name).join(", ");
          return `${result}, ${item.other_csos && item.other_csos.join(", ")}`;
        }
      },
      { text: vm.$t("actions"), sortable: false, width: "200px" }
    ],

    filteredItems() {
      if (this.filter.value)
        return this.items.filter(x => x.section.includes(this.filter.value));
      return this.items;
    },

    formTitle: vm =>
      vm.editedIndex > -1
        ? `Edit ${vm.$t("workshop")}`
        : `New  ${vm.$t("workshop")}`
  },

  methods: {
    deleteItem(item) {
      let vm = this;
      this.$alert(`/workshops/${item.id}`).then(() => {
        vm.items.splice(vm.items.indexOf(item), 1);
      });
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.workshop = Object.assign({}, item);
      this.dialog = true;
    },

    reset() {
      this.dialog = false;
      this.loading = false;
      this.editedIndex = -1;
      this.$validator.reset();
      this.workshop = {
        csos: [],
        id: null,
        name: null,
        start_date: new Date().toISOString().substring(0, 10),
        end_date: new Date().toISOString().substring(0, 10)
      };
    },

    save() {
      this.loading = true;
      this.$validator.validateAll().then(succeed => {
        if (succeed) {
          this.axios
            .post("workshops", this.workshop)
            .then(res => {
              if (this.editedIndex > -1)
                Object.assign(this.items[this.editedIndex], res.data.data);
              else this.items.push(res.data.data);
              this.reset();
            })
            .catch(() => (this.loading = false));
        } else {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true
          });
        }
      });
    },

    printTable(excel) {
      let data = {
        title: `Lists of ${this.$t("workshops")}`,
        items: this.filteredItems,
        headers: this.headers.slice(1, this.headers.length - 1)
      };

      if (excel) return this.xl_tables(data, this.$t("workshops"));
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },

    getData() {
      let filter = this.start_date ? `start_date=${this.start_date}` : "";
      filter = filter + (this.end_date ? `&&end_date=${this.end_date}` : "");
      this.axios.get(`workshops? ${filter}`).then(res => {
        this.items = res.data.data;
      });
    }
  },

  async created() {
    this.reset();
    this.getData();
    this.loading = true;
    await this.axios
      .get(`CSOs`)
      .then(res => {
        this.csos = res.data.data;
        this.loading = false;
      })
      .catch(vm => (vm.loading = false));
  }
};
</script>
